import React from 'react';
import {
  View,
  Text,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

interface PaymentDetailsSummaryProps {
  paymentAmount: number;
  fee: number;
  totalAmount: number;
  paymentMethodLabel: string;
  residentName?: string;
  containerStyle?: object;
}

/**
 * Reusable payment details summary component
 * Used in ConfirmPaymentContent and TransactionReceivedContent
 */
export const PaymentDetailsSummary: React.FC<PaymentDetailsSummaryProps> = ({
  paymentAmount,
  fee,
  totalAmount,
  paymentMethodLabel,
  residentName,
  containerStyle,
}) => {
  return (
    <View style={[styles.detailsContainer, containerStyle]}>
      {/* Payment on behalf of */}
      <View style={styles.detailRow}>
        <Text style={styles.detailLabel}>Payment on behalf of</Text>
        <Text style={styles.detailValue}>{residentName || 'Yourself'}</Text>
      </View>

      {/* Payment amount */}
      <View style={styles.detailRow}>
        <Text style={styles.detailLabel}>Payment amount</Text>
        <Text style={styles.detailValue}>{paymentAmount.toFixed(2)}</Text>
      </View>

      {/* Fee */}
      <View style={styles.detailRow}>
        <Text style={styles.detailLabel}>Fee</Text>
        <Text style={styles.detailValue}>{fee.toFixed(2)}</Text>
      </View>

      {/* Total */}
      <View style={styles.totalRow}>
        <Text style={styles.totalLabel}>
          Total charges to {paymentMethodLabel}
        </Text>
        <Text style={styles.totalValue}>
          $ {totalAmount.toFixed(2)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  detailsContainer: {
    gap: 4,
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 2,
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  detailValue: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 2,
    marginTop: 16,
  },
  totalLabel: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
  totalValue: {
    fontSize: 14,
    fontWeight: '500',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
});

export default PaymentDetailsSummary;
